import Icon from "scripts/components/basic/Icon.vue";
import Modal from "scripts/components/basic/Modal.vue";
import Tab from "scripts/components/basic/Tab.vue";
import Tabs from "scripts/components/basic/Tabs.vue";
import Accordion from "scripts/components/basic/Accordion.vue";
import AccordionGroup from "scripts/components/basic/AccordionGroup.vue";
import AccountSelectNav from "scripts/components/customers/AccountSelectNav.vue";
import CheckboxInputGroup from "scripts/components/forms/CheckboxInputGroup.vue";
import CustomerSelectInput from "scripts/components/forms/CustomerSelectInput.vue";
import CustomerTextInput from "scripts/components/forms/CustomerTextInput.vue";
import CustomerPasswordInput from "scripts/components/forms/CustomerPasswordInput.vue";
import Toast from "scripts/components/basic/Toast.vue";
import Carousel from "scripts/components/basic/Carousel.vue";
import Slide from "scripts/components/basic/Slide.vue";
import ImageGrid from "scripts/components/basic/ImageGrid.vue";
import FullOverlay from "scripts/components/basic/FullOverlay.vue";
import Vue100vh from "scripts/components/basic/Vue100vh.vue";
import ScrollingText from "scripts/components/basic/ScrollingText.vue";

import VButton from "scripts/components/buttons/VButton.vue";
import VArrowButton from "scripts/components/buttons/VArrowButton.vue";
import VLink from "scripts/components/buttons/VLink.vue";
import AsyncButton from "scripts/components/buttons/AsyncButton.vue";

import Cart from "scripts/components/cart/Cart.vue";
import Sidecart from "scripts/components/cart/Sidecart.vue";
import Navbar from "scripts/components/navigation/Navbar.vue";
import FooterToTop from "scripts/components/navigation/FooterToTop.vue";
import PromobarCarousel from "scripts/components/promobar/PromobarCarousel.vue";
import SearchResults from "scripts/components/search/SearchResults.vue";
import SwymBackInStock from "scripts/components/product/SwymBackInStock.vue";
import ProductTile from "scripts/components/product/ProductTile.vue";
import ProductDisplay from "scripts/components/product/ProductDisplay.vue";
import Collections from "scripts/components/pages/Collections.vue";
import CollectionBreadcrumbs from "scripts/components/collection/CollectionBreadcrumbs.vue";
import CollectionHero from "scripts/components/collection/CollectionHero.vue";
import BlogCategoryLinks from "scripts/components/blog/BlogCategoryLinks.vue";
import Press from 'scripts/components/blog/Press.vue';
import CollectionGrid from "scripts/components/collection/CollectionGrid.vue";
import VideoCarousel from "scripts/components/video/VideoCarousel.vue";
import VideoModal from "scripts/components/video/VideoModal.vue";
import YouTubeVideo from "scripts/components/video/YouTubeVideo.vue";
import About from "scripts/components/pages/About.vue";
import AboutImageBannerBlock from "scripts/components/sections/AboutImageBannerBlock.vue";
import Page404 from "scripts/components/pages/Page404.vue";
import FeaturedOffersLink from "scripts/components/featured-offers/FeaturedOffersLink.vue";

import NewsletterSignup from "scripts/components/newsletter/NewsletterSignup.vue";

import FooterBourdain from "scripts/components/footer/FooterBourdain.vue";
import FooterValueProps from "scripts/components/footer/FooterValueProps.vue";
import FooterEmailCollection from "scripts/components/footer/FooterEmailCollection.vue";
import FooterMain from "scripts/components/footer/FooterMain.vue";
import FooterContactSocial from "scripts/components/footer/FooterContactSocial.vue";
import FooterSubFooter from "scripts/components/footer/FooterSubFooter.vue";

// UI Kit
import SelectInput from "scripts/components/forms/SelectInput.vue";
import TextInput from "scripts/components/forms/TextInput.vue";
import EmailInput from "scripts/components/forms/EmailInput.vue";
import TextAreaInput from "scripts/components/forms/TextAreaInput.vue";
import RadioInput from "scripts/components/forms/RadioInput.vue";

//sections
import SplitWrapper from "scripts/components/basic/SplitWrapper.vue";
import HeroBanner from "scripts/components/sections/HeroBanner.vue";
import HeroBannerText from "scripts/components/sections/HeroBannerText.vue";
import ShoppableInstagram from "scripts/components/sections/ShoppableInstagram.vue";
import HeroBannerCarousel from "scripts/components/sections/HeroBannerCarousel.vue";
import BlogSection from "scripts/components/sections/BlogSection.vue";
import FeaturedCollection from "scripts/components/sections/FeaturedCollection.vue";
import FeaturedDesigner from "scripts/components/sections/FeaturedDesigner.vue";
import FeaturedInArticle from "scripts/components/sections/FeaturedInArticle.vue";
import CollectionLayoutTiles from "scripts/components/sections/CollectionLayoutTiles.vue";
import CollectionLayoutTilesTile from "scripts/components/sections/CollectionLayoutTilesTile.vue";
import CollectionLayoutLinear from "scripts/components/sections/CollectionLayoutLinear.vue";
import CollectionLayoutBlocks from "scripts/components/sections/CollectionLayoutBlocks.vue";
import TestimonialBlocks from "scripts/components/sections/TestimonialBlocks.vue";
import TestimonialCarousel from "scripts/components/sections/TestimonialCarousel.vue";
import InThePress from "scripts/components/sections/InThePress.vue";
import ImageStrip from "scripts/components/sections/ImageStrip.vue";
import Instagram from "scripts/components/sections/Instagram.vue";
import FiftyFifty from "scripts/components/sections/FiftyFifty.vue";
import FeaturedProduct from "scripts/components/sections/FeaturedProduct.vue";
import LinkDirectory from "scripts/components/sections/LinkDirectory.vue";
import ShopByPattern from "scripts/components/sections/ShopByPattern.vue";
import SeoContentBlock from "scripts/components/sections/SEOContentBlock.vue";
import SeoCollectionBlock from "scripts/components/sections/SEOCollectionBlock.vue";
import BrandMessage from "scripts/components/sections/BrandMessage.vue";
import CollectionLinks from "scripts/components/sections/CollectionLinks.vue";
import ProductSet from "scripts/components/sections/ProductSet.vue";

import FeaturedOffersContainer from "scripts/components/featured-offers/FeaturedOffersContainer.vue";
import EditorialSets from "scripts/components/sections/EditorialSets.vue";

// home page icon with text section
import IconWithText from './sections/IconWithText.vue'
// home page category slider section
import CategorySlider from './sections/CategorySlider.vue'
// Pages
import SubNav from "scripts/components/pages/SubNav.vue";
import FAQs from "scripts/components/pages/FAQs.vue";

// Super Collections
import SuperCollection from "scripts/components/pages/SuperCollection/SuperCollection.vue";
import SuperCollectionLinear from "scripts/components/pages/SuperCollection/SuperCollectionLinear.vue";

/**
 * Deferred components
 *
 * These components will only load if they are rendered by markup. Use
 * for components that don't load on every page.
 *
 * i.e. below the fold components, landing page components, etc.
 */
// const AsyncComponent = () => import('scripts/components/category/AsyncComponent.vue')

export default {
  Icon,
  Modal,
  Tab,
  Tabs,
  Accordion,
  AccordionGroup,
  AccountSelectNav,
  CheckboxInputGroup,
  CustomerSelectInput,
  CustomerTextInput,
  CustomerPasswordInput,
  Toast,
  Carousel,
  Slide,
  ImageGrid,
  VButton,
  VArrowButton,
  VLink,
  AsyncButton,
  Cart,
  Sidecart,
  Navbar,
  FooterToTop,
  SearchResults,
  SwymBackInStock,
  ProductTile,
  PromobarCarousel,
  ProductDisplay,
  CollectionGrid,
  CollectionHero,
  BlogCategoryLinks,
  Press,
  Collections,
  CollectionBreadcrumbs,
  VideoCarousel,
  VideoModal,
  YouTubeVideo,
  NewsletterSignup,
  About,
  AboutImageBannerBlock,
  Page404,
  FooterBourdain,
  FooterValueProps,
  FooterEmailCollection,
  FooterMain,
  FooterContactSocial,
  FooterSubFooter,
  FeaturedOffersLink,
  FullOverlay,
  Vue100vh,

  // ui-kit
  SelectInput,
  TextInput,
  EmailInput,
  RadioInput,
  TextAreaInput,

  // sections
  SplitWrapper,
  HeroBanner,
  HeroBannerText,
  ShoppableInstagram,
  HeroBannerCarousel,
  BlogSection,
  FeaturedCollection,
  FeaturedDesigner,
  FeaturedInArticle,
  CollectionLayoutTiles,
  CollectionLayoutTilesTile,
  CollectionLayoutLinear,
  CollectionLayoutBlocks,
  TestimonialBlocks,
  TestimonialCarousel,
  InThePress,
  ImageStrip,
  Instagram,
  FiftyFifty,
  FeaturedProduct,
  FeaturedOffersContainer,
  LinkDirectory,
  ShopByPattern,
  EditorialSets,
  BrandMessage,
  SeoContentBlock,
  SeoCollectionBlock,
  CollectionLinks,
  ProductSet,
  IconWithText,
  CategorySlider,
  // pages
  SubNav,
  faqs: FAQs,

  // super collection
  SuperCollection,
  SuperCollectionLinear

};
